import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export const useThemeStore = create(
  persist(
    (set, get) => ({
      theme: 'light', // 'light' | 'dark'

      // Toggle theme
      toggleTheme: () => {
        const newTheme = get().theme === 'light' ? 'dark' : 'light'
        set({ theme: newTheme })
      },

      // Set specific theme
      setTheme: (theme) => {
        set({ theme })
      },

      // Get system theme preference
      getSystemTheme: () => {
        if (typeof window !== 'undefined') {
          return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light'
        }
        return 'light'
      },

      // Set theme based on system preference
      setSystemTheme: () => {
        const systemTheme = get().getSystemTheme()
        set({ theme: systemTheme })
      },
    }),
    {
      name: 'theme-storage',
    }
  )
)